
export default {
  'cmdb.models.list': {
    data: ({ state }) => {
      return {
        current: state && state.cmdb && state.cmdb.current
      }
    },
    method: {
      onSwitch: ({ dispatch }) => (model) => {
        dispatch({ type: '@@cmdb/CHANGE_CURRENT', id: model.id })
      }
    }
  },

}
